import React from 'react';
import { NavBar } from '../components/NavBar';
import { SalesContent } from '../components/SalesContent';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-227">
      <NavBar data-id="element-228" />
      <main className="flex-grow" data-id="element-229">
        <SalesContent data-id="element-230" />
      </main>
      <Footer data-id="element-231" />
    </div>;
}